
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    // @ts-check
// @ts-check
var $ae40fb19cfbdaff6$exports = {};
$ae40fb19cfbdaff6$exports = JSON.parse("{\"name\":\"Jupiter\",\"slug\":\"jupiter\",\"version\":\"3.0.0\",\"palette\":{\"cyan\":\"#00B2DF\",\"blue\":\"#168BC1\",\"indigo\":\"#557DBD\",\"violet\":\"#746FBB\",\"magenta\":\"#BF6573\",\"rose\":\"#D96D66\",\"red\":\"#D8524B\",\"orange\":\"#D96F42\",\"amber\":\"#C78C00\",\"yellow\":\"#C7AB28\",\"green\":\"#9FA95A\",\"mint\":\"#46A991\"},\"roles\":{\"syntax\":{\"constant\":\"cyan\",\"identifier\":\"blue\",\"statement\":\"amber\",\"type\":\"green\",\"global\":\"violet\",\"emphasis\":\"magenta\",\"special\":\"orange\",\"string\":\"mint\",\"regexp\":\"rose\",\"number\":\"yellow\",\"operator\":\"indigo\",\"tag\":\"blue\",\"attribute\":\"cyan\",\"deleted\":\"red\",\"inserted\":\"green\",\"changed\":\"amber\"},\"ui\":{\"userActionNeeded\":\"red\",\"userCurrentState\":\"cyan\"}},\"variants\":{\"metis\":{\"name\":\"Metis\",\"slug\":\"metis\",\"palette\":{\"cyan\":\"#00B2DF\",\"blue\":\"#168BC1\",\"indigo\":\"#557DBD\",\"violet\":\"#746FBB\",\"magenta\":\"#BF6573\",\"rose\":\"#D96D66\",\"red\":\"#D8524B\",\"orange\":\"#D96F42\",\"amber\":\"#C78C00\",\"yellow\":\"#C7AB28\",\"green\":\"#9FA95A\",\"mint\":\"#46A991\"},\"roles\":{\"syntax\":{\"constant\":\"cyan\",\"identifier\":\"blue\",\"statement\":\"amber\",\"type\":\"green\",\"global\":\"violet\",\"emphasis\":\"magenta\",\"special\":\"orange\",\"string\":\"mint\",\"regexp\":\"rose\",\"number\":\"yellow\",\"operator\":\"indigo\",\"tag\":\"blue\",\"attribute\":\"cyan\",\"deleted\":\"red\",\"inserted\":\"green\",\"changed\":\"amber\"},\"ui\":{\"userActionNeeded\":\"red\",\"userCurrentState\":\"cyan\"}},\"themes\":{\"dark\":{\"name\":\"Metis Dark\",\"slug\":\"metis-dark\",\"variant\":\"metis\",\"type\":\"dark\",\"colors\":{\"cyan\":\"#38C2E6\",\"blue\":\"#2DA8D8\",\"indigo\":\"#6A9BD8\",\"violet\":\"#8C8CD7\",\"magenta\":\"#DD747D\",\"rose\":\"#F07D75\",\"red\":\"#F25F57\",\"orange\":\"#F47B4F\",\"amber\":\"#F0A818\",\"yellow\":\"#EFC852\",\"green\":\"#C7C46B\",\"mint\":\"#6BC7B5\"},\"grays\":{\"gray0\":\"#041D2B\",\"gray1\":\"#082D42\",\"gray2\":\"#104B68\",\"gray3\":\"#80B8D2\",\"gray4\":\"#6096B2\",\"gray5\":\"#9CCFE7\",\"gray6\":\"#DCEBF5\"},\"uiGroups\":{\"backgroundShade\":\"#041D2B\",\"background\":\"#082D42\",\"backgroundElevated\":\"#0B3A54\",\"backgroundMuted\":\"#104B68\",\"selection\":\"#176F96\",\"foreground\":\"#DCEBF5\",\"foregroundMuted\":\"#9CCFE7\",\"foregroundSubtle\":\"#6096B2\",\"border\":\"#2E6D8A\",\"line\":\"#80B8D2\",\"userActionNeeded\":\"#F25F57\",\"userCurrentState\":\"#38C2E6\",\"gray0\":\"#041D2B\",\"gray1\":\"#082D42\",\"gray2\":\"#104B68\",\"gray3\":\"#80B8D2\",\"gray4\":\"#6096B2\",\"gray5\":\"#9CCFE7\",\"gray6\":\"#DCEBF5\"},\"syntaxGroups\":{\"constant\":\"#38C2E6\",\"identifier\":\"#2DA8D8\",\"statement\":\"#F0A818\",\"type\":\"#C7C46B\",\"global\":\"#8C8CD7\",\"emphasis\":\"#DD747D\",\"special\":\"#F47B4F\",\"string\":\"#6BC7B5\",\"regexp\":\"#F07D75\",\"number\":\"#EFC852\",\"operator\":\"#6A9BD8\",\"tag\":\"#2DA8D8\",\"attribute\":\"#38C2E6\",\"trivial\":\"#6096B2\"},\"versionControlGroups\":{\"added\":\"#C7C46B\",\"modified\":\"#F0A818\",\"removed\":\"#F25F57\",\"renamed\":\"#2DA8D8\"},\"ansiGroups\":{\"normal\":{\"black\":\"#082D42\",\"red\":\"#F25F57\",\"green\":\"#C7C46B\",\"yellow\":\"#F0A818\",\"blue\":\"#2DA8D8\",\"magenta\":\"#DD747D\",\"cyan\":\"#38C2E6\",\"white\":\"#DCEBF5\"},\"bright\":{\"black\":\"#6096B2\",\"red\":\"#F07D75\",\"green\":\"#6BC7B5\",\"yellow\":\"#EFC852\",\"blue\":\"#6A9BD8\",\"magenta\":\"#8C8CD7\",\"cyan\":\"#38C2E6\",\"white\":\"#F5FAFD\"}}},\"light\":{\"name\":\"Metis Light\",\"slug\":\"metis-light\",\"variant\":\"metis\",\"type\":\"light\",\"colors\":{\"cyan\":\"#007FA3\",\"blue\":\"#0877A8\",\"indigo\":\"#4A6FA5\",\"violet\":\"#675FA3\",\"magenta\":\"#A84D5E\",\"rose\":\"#B85752\",\"red\":\"#B73D38\",\"orange\":\"#B75B31\",\"amber\":\"#946E00\",\"yellow\":\"#836F0A\",\"green\":\"#74772E\",\"mint\":\"#27826F\"},\"grays\":{\"gray0\":\"#DDEFF7\",\"gray1\":\"#F7FCFE\",\"gray2\":\"#D5EDF7\",\"gray3\":\"#82B6CE\",\"gray4\":\"#5C8396\",\"gray5\":\"#335F74\",\"gray6\":\"#0B2F44\"},\"uiGroups\":{\"backgroundShade\":\"#DDEFF7\",\"background\":\"#F7FCFE\",\"backgroundElevated\":\"#ECF7FC\",\"backgroundMuted\":\"#D5EDF7\",\"selection\":\"#BAE8F6\",\"foreground\":\"#0B2F44\",\"foregroundMuted\":\"#335F74\",\"foregroundSubtle\":\"#5C8396\",\"border\":\"#B9D8E6\",\"line\":\"#82B6CE\",\"userActionNeeded\":\"#B73D38\",\"userCurrentState\":\"#007FA3\",\"gray0\":\"#DDEFF7\",\"gray1\":\"#F7FCFE\",\"gray2\":\"#D5EDF7\",\"gray3\":\"#82B6CE\",\"gray4\":\"#5C8396\",\"gray5\":\"#335F74\",\"gray6\":\"#0B2F44\"},\"syntaxGroups\":{\"constant\":\"#007FA3\",\"identifier\":\"#0877A8\",\"statement\":\"#946E00\",\"type\":\"#74772E\",\"global\":\"#675FA3\",\"emphasis\":\"#A84D5E\",\"special\":\"#B75B31\",\"string\":\"#27826F\",\"regexp\":\"#B85752\",\"number\":\"#836F0A\",\"operator\":\"#4A6FA5\",\"tag\":\"#0877A8\",\"attribute\":\"#007FA3\",\"trivial\":\"#5C8396\"},\"versionControlGroups\":{\"added\":\"#74772E\",\"modified\":\"#946E00\",\"removed\":\"#B73D38\",\"renamed\":\"#0877A8\"},\"ansiGroups\":{\"normal\":{\"black\":\"#F7FCFE\",\"red\":\"#B73D38\",\"green\":\"#74772E\",\"yellow\":\"#946E00\",\"blue\":\"#0877A8\",\"magenta\":\"#A84D5E\",\"cyan\":\"#007FA3\",\"white\":\"#0B2F44\"},\"bright\":{\"black\":\"#5C8396\",\"red\":\"#B85752\",\"green\":\"#27826F\",\"yellow\":\"#836F0A\",\"blue\":\"#4A6FA5\",\"magenta\":\"#675FA3\",\"cyan\":\"#007FA3\",\"white\":\"#FFFFFF\"}}}}},\"ganymede\":{\"name\":\"Ganymede\",\"slug\":\"ganymede\",\"palette\":{\"cyan\":\"#00B7ED\",\"blue\":\"#00B7ED\",\"yellow\":\"#FFBA00\",\"green\":\"#F1D677\",\"purple\":\"#F25A55\",\"red\":\"#F25A55\",\"orange\":\"#F25A55\",\"pink\":\"#F5837F\"},\"roles\":{\"syntax\":{\"constant\":\"cyan\",\"identifier\":\"blue\",\"statement\":\"yellow\",\"type\":\"green\",\"global\":\"purple\",\"emphasis\":\"pink\",\"special\":\"orange\",\"string\":\"red\",\"regexp\":\"pink\",\"number\":\"yellow\",\"operator\":\"cyan\",\"tag\":\"blue\",\"attribute\":\"yellow\",\"deleted\":\"red\",\"inserted\":\"green\",\"changed\":\"orange\"},\"ui\":{\"userActionNeeded\":\"red\",\"userCurrentState\":\"cyan\"}},\"themes\":{\"dark\":{\"name\":\"Ganymede Dark\",\"slug\":\"ganymede-dark\",\"variant\":\"ganymede\",\"type\":\"dark\",\"colors\":{\"cyan\":\"#00B7ED\",\"blue\":\"#00B7ED\",\"yellow\":\"#FFBA00\",\"green\":\"#F1D677\",\"purple\":\"#F25A55\",\"red\":\"#F25A55\",\"orange\":\"#F25A55\",\"pink\":\"#F5837F\"},\"grays\":{\"gray0\":\"#022538\",\"gray1\":\"#093750\",\"gray2\":\"#055682\",\"gray3\":\"#A2D9F5\",\"gray4\":\"#1C7DB1\",\"gray5\":\"#A2D9F5\",\"gray6\":\"#DCEBF5\"},\"uiGroups\":{\"backgroundShade\":\"#022538\",\"background\":\"#093750\",\"backgroundElevated\":\"#0B4867\",\"backgroundMuted\":\"#055682\",\"selection\":\"#1C7DB1\",\"foreground\":\"#DCEBF5\",\"foregroundMuted\":\"#A2D9F5\",\"foregroundSubtle\":\"#1C7DB1\",\"border\":\"#1C7DB1\",\"line\":\"#A2D9F5\",\"userActionNeeded\":\"#F25A55\",\"userCurrentState\":\"#00B7ED\",\"gray0\":\"#022538\",\"gray1\":\"#093750\",\"gray2\":\"#055682\",\"gray3\":\"#A2D9F5\",\"gray4\":\"#1C7DB1\",\"gray5\":\"#A2D9F5\",\"gray6\":\"#DCEBF5\"},\"syntaxGroups\":{\"constant\":\"#00B7ED\",\"identifier\":\"#00B7ED\",\"statement\":\"#FFBA00\",\"type\":\"#F1D677\",\"global\":\"#F25A55\",\"emphasis\":\"#F5837F\",\"special\":\"#F25A55\",\"string\":\"#F25A55\",\"regexp\":\"#F5837F\",\"number\":\"#FFBA00\",\"operator\":\"#00B7ED\",\"tag\":\"#00B7ED\",\"attribute\":\"#FFBA00\",\"trivial\":\"#1C7DB1\"},\"versionControlGroups\":{\"added\":\"#F1D677\",\"modified\":\"#F25A55\",\"removed\":\"#F25A55\",\"renamed\":\"#00B7ED\"},\"ansiGroups\":{\"normal\":{\"black\":\"#093750\",\"red\":\"#F25A55\",\"green\":\"#F1D677\",\"yellow\":\"#FFBA00\",\"blue\":\"#00B7ED\",\"magenta\":\"#F5837F\",\"cyan\":\"#00B7ED\",\"white\":\"#DCEBF5\"},\"bright\":{\"black\":\"#1C7DB1\",\"red\":\"#F25A55\",\"green\":\"#F1D677\",\"yellow\":\"#FFBA00\",\"blue\":\"#00B7ED\",\"magenta\":\"#F5837F\",\"cyan\":\"#00B7ED\",\"white\":\"#F5FAFD\"}}},\"light\":{\"name\":\"Ganymede Light\",\"slug\":\"ganymede-light\",\"variant\":\"ganymede\",\"type\":\"light\",\"colors\":{\"cyan\":\"#007EA3\",\"blue\":\"#007EA3\",\"yellow\":\"#9E7100\",\"green\":\"#6F641B\",\"purple\":\"#B53331\",\"red\":\"#B53331\",\"orange\":\"#B53331\",\"pink\":\"#B6524F\"},\"grays\":{\"gray0\":\"#D8EEF8\",\"gray1\":\"#F4FBFE\",\"gray2\":\"#CFEAF6\",\"gray3\":\"#79AFC9\",\"gray4\":\"#557E92\",\"gray5\":\"#315B71\",\"gray6\":\"#093750\"},\"uiGroups\":{\"backgroundShade\":\"#D8EEF8\",\"background\":\"#F4FBFE\",\"backgroundElevated\":\"#E7F5FB\",\"backgroundMuted\":\"#CFEAF6\",\"selection\":\"#B4E5F6\",\"foreground\":\"#093750\",\"foregroundMuted\":\"#315B71\",\"foregroundSubtle\":\"#557E92\",\"border\":\"#AED2E3\",\"line\":\"#79AFC9\",\"userActionNeeded\":\"#B53331\",\"userCurrentState\":\"#007EA3\",\"gray0\":\"#D8EEF8\",\"gray1\":\"#F4FBFE\",\"gray2\":\"#CFEAF6\",\"gray3\":\"#79AFC9\",\"gray4\":\"#557E92\",\"gray5\":\"#315B71\",\"gray6\":\"#093750\"},\"syntaxGroups\":{\"constant\":\"#007EA3\",\"identifier\":\"#007EA3\",\"statement\":\"#9E7100\",\"type\":\"#6F641B\",\"global\":\"#B53331\",\"emphasis\":\"#B6524F\",\"special\":\"#B53331\",\"string\":\"#B53331\",\"regexp\":\"#B6524F\",\"number\":\"#9E7100\",\"operator\":\"#007EA3\",\"tag\":\"#007EA3\",\"attribute\":\"#9E7100\",\"trivial\":\"#557E92\"},\"versionControlGroups\":{\"added\":\"#6F641B\",\"modified\":\"#B53331\",\"removed\":\"#B53331\",\"renamed\":\"#007EA3\"},\"ansiGroups\":{\"normal\":{\"black\":\"#F4FBFE\",\"red\":\"#B53331\",\"green\":\"#6F641B\",\"yellow\":\"#9E7100\",\"blue\":\"#007EA3\",\"magenta\":\"#B6524F\",\"cyan\":\"#007EA3\",\"white\":\"#093750\"},\"bright\":{\"black\":\"#557E92\",\"red\":\"#B53331\",\"green\":\"#6F641B\",\"yellow\":\"#9E7100\",\"blue\":\"#007EA3\",\"magenta\":\"#B6524F\",\"cyan\":\"#007EA3\",\"white\":\"#FFFFFF\"}}}}},\"callisto\":{\"name\":\"Callisto\",\"slug\":\"callisto\",\"palette\":{\"cyan\":\"#00C7F2\",\"blue\":\"#4C86F7\",\"indigo\":\"#7168F2\",\"violet\":\"#9C57E8\",\"magenta\":\"#D94FC4\",\"rose\":\"#F04D81\",\"red\":\"#F24A55\",\"orange\":\"#F06D2E\",\"amber\":\"#D88E00\",\"yellow\":\"#D5B72E\",\"green\":\"#72B846\",\"mint\":\"#21B993\"},\"roles\":{\"syntax\":{\"constant\":\"cyan\",\"identifier\":\"blue\",\"statement\":\"amber\",\"type\":\"green\",\"global\":\"violet\",\"emphasis\":\"magenta\",\"special\":\"orange\",\"string\":\"mint\",\"regexp\":\"rose\",\"number\":\"yellow\",\"operator\":\"indigo\",\"tag\":\"blue\",\"attribute\":\"cyan\",\"deleted\":\"red\",\"inserted\":\"green\",\"changed\":\"amber\"},\"ui\":{\"userActionNeeded\":\"red\",\"userCurrentState\":\"cyan\"}},\"themes\":{\"dark\":{\"name\":\"Callisto Dark\",\"slug\":\"callisto-dark\",\"variant\":\"callisto\",\"type\":\"dark\",\"colors\":{\"cyan\":\"#1BD7FF\",\"blue\":\"#6A9BFF\",\"indigo\":\"#8A7DFF\",\"violet\":\"#B46AFF\",\"magenta\":\"#F05ADB\",\"rose\":\"#FF5D91\",\"red\":\"#FF5662\",\"orange\":\"#FF853B\",\"amber\":\"#FFAD13\",\"yellow\":\"#F6D950\",\"green\":\"#8CDD57\",\"mint\":\"#37D8AE\"},\"grays\":{\"gray0\":\"#03060B\",\"gray1\":\"#070B12\",\"gray2\":\"#151E2D\",\"gray3\":\"#566987\",\"gray4\":\"#667890\",\"gray5\":\"#B0BED3\",\"gray6\":\"#E8EEF8\"},\"uiGroups\":{\"backgroundShade\":\"#03060B\",\"background\":\"#070B12\",\"backgroundElevated\":\"#0D1320\",\"backgroundMuted\":\"#151E2D\",\"selection\":\"#263D66\",\"foreground\":\"#E8EEF8\",\"foregroundMuted\":\"#B0BED3\",\"foregroundSubtle\":\"#667890\",\"border\":\"#253349\",\"line\":\"#566987\",\"userActionNeeded\":\"#FF5662\",\"userCurrentState\":\"#1BD7FF\",\"gray0\":\"#03060B\",\"gray1\":\"#070B12\",\"gray2\":\"#151E2D\",\"gray3\":\"#566987\",\"gray4\":\"#667890\",\"gray5\":\"#B0BED3\",\"gray6\":\"#E8EEF8\"},\"syntaxGroups\":{\"constant\":\"#1BD7FF\",\"identifier\":\"#6A9BFF\",\"statement\":\"#FFAD13\",\"type\":\"#8CDD57\",\"global\":\"#B46AFF\",\"emphasis\":\"#F05ADB\",\"special\":\"#FF853B\",\"string\":\"#37D8AE\",\"regexp\":\"#FF5D91\",\"number\":\"#F6D950\",\"operator\":\"#8A7DFF\",\"tag\":\"#6A9BFF\",\"attribute\":\"#1BD7FF\",\"trivial\":\"#667890\"},\"versionControlGroups\":{\"added\":\"#8CDD57\",\"modified\":\"#FFAD13\",\"removed\":\"#FF5662\",\"renamed\":\"#6A9BFF\"},\"ansiGroups\":{\"normal\":{\"black\":\"#070B12\",\"red\":\"#FF5662\",\"green\":\"#8CDD57\",\"yellow\":\"#FFAD13\",\"blue\":\"#6A9BFF\",\"magenta\":\"#F05ADB\",\"cyan\":\"#1BD7FF\",\"white\":\"#E8EEF8\"},\"bright\":{\"black\":\"#667890\",\"red\":\"#FF5D91\",\"green\":\"#37D8AE\",\"yellow\":\"#F6D950\",\"blue\":\"#8A7DFF\",\"magenta\":\"#B46AFF\",\"cyan\":\"#1BD7FF\",\"white\":\"#F5FAFD\"}}},\"light\":{\"name\":\"Callisto Light\",\"slug\":\"callisto-light\",\"variant\":\"callisto\",\"type\":\"light\",\"colors\":{\"cyan\":\"#007EA0\",\"blue\":\"#285FC5\",\"indigo\":\"#5149B7\",\"violet\":\"#7636A8\",\"magenta\":\"#A93494\",\"rose\":\"#B93663\",\"red\":\"#B9353F\",\"orange\":\"#B85220\",\"amber\":\"#8F6100\",\"yellow\":\"#786500\",\"green\":\"#4F7D25\",\"mint\":\"#168065\"},\"grays\":{\"gray0\":\"#DCE4EF\",\"gray1\":\"#F2F6FB\",\"gray2\":\"#D7E1ED\",\"gray3\":\"#7F90AA\",\"gray4\":\"#66748A\",\"gray5\":\"#40516A\",\"gray6\":\"#111B2A\"},\"uiGroups\":{\"backgroundShade\":\"#DCE4EF\",\"background\":\"#F2F6FB\",\"backgroundElevated\":\"#E8EEF7\",\"backgroundMuted\":\"#D7E1ED\",\"selection\":\"#B6C8E8\",\"foreground\":\"#111B2A\",\"foregroundMuted\":\"#40516A\",\"foregroundSubtle\":\"#66748A\",\"border\":\"#B5C1D1\",\"line\":\"#7F90AA\",\"userActionNeeded\":\"#B9353F\",\"userCurrentState\":\"#007EA0\",\"gray0\":\"#DCE4EF\",\"gray1\":\"#F2F6FB\",\"gray2\":\"#D7E1ED\",\"gray3\":\"#7F90AA\",\"gray4\":\"#66748A\",\"gray5\":\"#40516A\",\"gray6\":\"#111B2A\"},\"syntaxGroups\":{\"constant\":\"#007EA0\",\"identifier\":\"#285FC5\",\"statement\":\"#8F6100\",\"type\":\"#4F7D25\",\"global\":\"#7636A8\",\"emphasis\":\"#A93494\",\"special\":\"#B85220\",\"string\":\"#168065\",\"regexp\":\"#B93663\",\"number\":\"#786500\",\"operator\":\"#5149B7\",\"tag\":\"#285FC5\",\"attribute\":\"#007EA0\",\"trivial\":\"#66748A\"},\"versionControlGroups\":{\"added\":\"#4F7D25\",\"modified\":\"#8F6100\",\"removed\":\"#B9353F\",\"renamed\":\"#285FC5\"},\"ansiGroups\":{\"normal\":{\"black\":\"#F2F6FB\",\"red\":\"#B9353F\",\"green\":\"#4F7D25\",\"yellow\":\"#8F6100\",\"blue\":\"#285FC5\",\"magenta\":\"#A93494\",\"cyan\":\"#007EA0\",\"white\":\"#111B2A\"},\"bright\":{\"black\":\"#66748A\",\"red\":\"#B93663\",\"green\":\"#168065\",\"yellow\":\"#786500\",\"blue\":\"#5149B7\",\"magenta\":\"#7636A8\",\"cyan\":\"#007EA0\",\"white\":\"#FFFFFF\"}}}}},\"europa\":{\"name\":\"Europa\",\"slug\":\"europa\",\"palette\":{\"cyan\":\"#8ED8E8\",\"blue\":\"#7FAFE4\",\"indigo\":\"#8B93D9\",\"violet\":\"#A58AD1\",\"magenta\":\"#C982B3\",\"rose\":\"#D77F8A\",\"red\":\"#C95C4E\",\"orange\":\"#C9783F\",\"amber\":\"#B88F42\",\"yellow\":\"#C7B66A\",\"green\":\"#98B878\",\"mint\":\"#78BFAE\"},\"roles\":{\"syntax\":{\"constant\":\"cyan\",\"identifier\":\"blue\",\"statement\":\"amber\",\"type\":\"green\",\"global\":\"violet\",\"emphasis\":\"magenta\",\"special\":\"orange\",\"string\":\"mint\",\"regexp\":\"rose\",\"number\":\"yellow\",\"operator\":\"indigo\",\"tag\":\"blue\",\"attribute\":\"cyan\",\"deleted\":\"red\",\"inserted\":\"green\",\"changed\":\"amber\"},\"ui\":{\"userActionNeeded\":\"red\",\"userCurrentState\":\"cyan\"}},\"themes\":{\"dark\":{\"name\":\"Europa Dark\",\"slug\":\"europa-dark\",\"variant\":\"europa\",\"type\":\"dark\",\"colors\":{\"cyan\":\"#A6E8F4\",\"blue\":\"#93C7F5\",\"indigo\":\"#A9ADF6\",\"violet\":\"#C2A6F0\",\"magenta\":\"#E79BD0\",\"rose\":\"#F29BA4\",\"red\":\"#E57965\",\"orange\":\"#E69554\",\"amber\":\"#D9B35F\",\"yellow\":\"#E3D789\",\"green\":\"#B7D694\",\"mint\":\"#93DBC9\"},\"grays\":{\"gray0\":\"#071017\",\"gray1\":\"#0D1A24\",\"gray2\":\"#203342\",\"gray3\":\"#7893A0\",\"gray4\":\"#7F98A4\",\"gray5\":\"#BAC9D0\",\"gray6\":\"#E7EEF2\"},\"uiGroups\":{\"backgroundShade\":\"#071017\",\"background\":\"#0D1A24\",\"backgroundElevated\":\"#142532\",\"backgroundMuted\":\"#203342\",\"selection\":\"#34576B\",\"foreground\":\"#E7EEF2\",\"foregroundMuted\":\"#BAC9D0\",\"foregroundSubtle\":\"#7F98A4\",\"border\":\"#3B5360\",\"line\":\"#7893A0\",\"userActionNeeded\":\"#E57965\",\"userCurrentState\":\"#A6E8F4\",\"gray0\":\"#071017\",\"gray1\":\"#0D1A24\",\"gray2\":\"#203342\",\"gray3\":\"#7893A0\",\"gray4\":\"#7F98A4\",\"gray5\":\"#BAC9D0\",\"gray6\":\"#E7EEF2\"},\"syntaxGroups\":{\"constant\":\"#A6E8F4\",\"identifier\":\"#93C7F5\",\"statement\":\"#D9B35F\",\"type\":\"#B7D694\",\"global\":\"#C2A6F0\",\"emphasis\":\"#E79BD0\",\"special\":\"#E69554\",\"string\":\"#93DBC9\",\"regexp\":\"#F29BA4\",\"number\":\"#E3D789\",\"operator\":\"#A9ADF6\",\"tag\":\"#93C7F5\",\"attribute\":\"#A6E8F4\",\"trivial\":\"#7F98A4\"},\"versionControlGroups\":{\"added\":\"#B7D694\",\"modified\":\"#D9B35F\",\"removed\":\"#E57965\",\"renamed\":\"#93C7F5\"},\"ansiGroups\":{\"normal\":{\"black\":\"#0D1A24\",\"red\":\"#E57965\",\"green\":\"#B7D694\",\"yellow\":\"#D9B35F\",\"blue\":\"#93C7F5\",\"magenta\":\"#E79BD0\",\"cyan\":\"#A6E8F4\",\"white\":\"#E7EEF2\"},\"bright\":{\"black\":\"#7F98A4\",\"red\":\"#F29BA4\",\"green\":\"#93DBC9\",\"yellow\":\"#E3D789\",\"blue\":\"#A9ADF6\",\"magenta\":\"#C2A6F0\",\"cyan\":\"#A6E8F4\",\"white\":\"#F5FAFD\"}}},\"light\":{\"name\":\"Europa Light\",\"slug\":\"europa-light\",\"variant\":\"europa\",\"type\":\"light\",\"colors\":{\"cyan\":\"#4B8FA0\",\"blue\":\"#4779B1\",\"indigo\":\"#656CAD\",\"violet\":\"#7B62A2\",\"magenta\":\"#985F86\",\"rose\":\"#A85E68\",\"red\":\"#9E483E\",\"orange\":\"#9F5C2D\",\"amber\":\"#80652F\",\"yellow\":\"#726A35\",\"green\":\"#617A43\",\"mint\":\"#4D8377\"},\"grays\":{\"gray0\":\"#DDE9ED\",\"gray1\":\"#F8FBFC\",\"gray2\":\"#DCE9ED\",\"gray3\":\"#8EA5AE\",\"gray4\":\"#78909A\",\"gray5\":\"#4D6571\",\"gray6\":\"#172B35\"},\"uiGroups\":{\"backgroundShade\":\"#DDE9ED\",\"background\":\"#F8FBFC\",\"backgroundElevated\":\"#EEF5F7\",\"backgroundMuted\":\"#DCE9ED\",\"selection\":\"#C3DDE6\",\"foreground\":\"#172B35\",\"foregroundMuted\":\"#4D6571\",\"foregroundSubtle\":\"#78909A\",\"border\":\"#C0D0D6\",\"line\":\"#8EA5AE\",\"userActionNeeded\":\"#9E483E\",\"userCurrentState\":\"#4B8FA0\",\"gray0\":\"#DDE9ED\",\"gray1\":\"#F8FBFC\",\"gray2\":\"#DCE9ED\",\"gray3\":\"#8EA5AE\",\"gray4\":\"#78909A\",\"gray5\":\"#4D6571\",\"gray6\":\"#172B35\"},\"syntaxGroups\":{\"constant\":\"#4B8FA0\",\"identifier\":\"#4779B1\",\"statement\":\"#80652F\",\"type\":\"#617A43\",\"global\":\"#7B62A2\",\"emphasis\":\"#985F86\",\"special\":\"#9F5C2D\",\"string\":\"#4D8377\",\"regexp\":\"#A85E68\",\"number\":\"#726A35\",\"operator\":\"#656CAD\",\"tag\":\"#4779B1\",\"attribute\":\"#4B8FA0\",\"trivial\":\"#78909A\"},\"versionControlGroups\":{\"added\":\"#617A43\",\"modified\":\"#80652F\",\"removed\":\"#9E483E\",\"renamed\":\"#4779B1\"},\"ansiGroups\":{\"normal\":{\"black\":\"#F8FBFC\",\"red\":\"#9E483E\",\"green\":\"#617A43\",\"yellow\":\"#80652F\",\"blue\":\"#4779B1\",\"magenta\":\"#985F86\",\"cyan\":\"#4B8FA0\",\"white\":\"#172B35\"},\"bright\":{\"black\":\"#78909A\",\"red\":\"#A85E68\",\"green\":\"#4D8377\",\"yellow\":\"#726A35\",\"blue\":\"#656CAD\",\"magenta\":\"#7B62A2\",\"cyan\":\"#4B8FA0\",\"white\":\"#FFFFFF\"}}}}}},\"themes\":{\"dark\":{\"name\":\"Metis Dark\",\"slug\":\"metis-dark\",\"variant\":\"metis\",\"type\":\"dark\",\"colors\":{\"cyan\":\"#38C2E6\",\"blue\":\"#2DA8D8\",\"indigo\":\"#6A9BD8\",\"violet\":\"#8C8CD7\",\"magenta\":\"#DD747D\",\"rose\":\"#F07D75\",\"red\":\"#F25F57\",\"orange\":\"#F47B4F\",\"amber\":\"#F0A818\",\"yellow\":\"#EFC852\",\"green\":\"#C7C46B\",\"mint\":\"#6BC7B5\"},\"grays\":{\"gray0\":\"#041D2B\",\"gray1\":\"#082D42\",\"gray2\":\"#104B68\",\"gray3\":\"#80B8D2\",\"gray4\":\"#6096B2\",\"gray5\":\"#9CCFE7\",\"gray6\":\"#DCEBF5\"},\"uiGroups\":{\"backgroundShade\":\"#041D2B\",\"background\":\"#082D42\",\"backgroundElevated\":\"#0B3A54\",\"backgroundMuted\":\"#104B68\",\"selection\":\"#176F96\",\"foreground\":\"#DCEBF5\",\"foregroundMuted\":\"#9CCFE7\",\"foregroundSubtle\":\"#6096B2\",\"border\":\"#2E6D8A\",\"line\":\"#80B8D2\",\"userActionNeeded\":\"#F25F57\",\"userCurrentState\":\"#38C2E6\",\"gray0\":\"#041D2B\",\"gray1\":\"#082D42\",\"gray2\":\"#104B68\",\"gray3\":\"#80B8D2\",\"gray4\":\"#6096B2\",\"gray5\":\"#9CCFE7\",\"gray6\":\"#DCEBF5\"},\"syntaxGroups\":{\"constant\":\"#38C2E6\",\"identifier\":\"#2DA8D8\",\"statement\":\"#F0A818\",\"type\":\"#C7C46B\",\"global\":\"#8C8CD7\",\"emphasis\":\"#DD747D\",\"special\":\"#F47B4F\",\"string\":\"#6BC7B5\",\"regexp\":\"#F07D75\",\"number\":\"#EFC852\",\"operator\":\"#6A9BD8\",\"tag\":\"#2DA8D8\",\"attribute\":\"#38C2E6\",\"trivial\":\"#6096B2\"},\"versionControlGroups\":{\"added\":\"#C7C46B\",\"modified\":\"#F0A818\",\"removed\":\"#F25F57\",\"renamed\":\"#2DA8D8\"},\"ansiGroups\":{\"normal\":{\"black\":\"#082D42\",\"red\":\"#F25F57\",\"green\":\"#C7C46B\",\"yellow\":\"#F0A818\",\"blue\":\"#2DA8D8\",\"magenta\":\"#DD747D\",\"cyan\":\"#38C2E6\",\"white\":\"#DCEBF5\"},\"bright\":{\"black\":\"#6096B2\",\"red\":\"#F07D75\",\"green\":\"#6BC7B5\",\"yellow\":\"#EFC852\",\"blue\":\"#6A9BD8\",\"magenta\":\"#8C8CD7\",\"cyan\":\"#38C2E6\",\"white\":\"#F5FAFD\"}}},\"light\":{\"name\":\"Metis Light\",\"slug\":\"metis-light\",\"variant\":\"metis\",\"type\":\"light\",\"colors\":{\"cyan\":\"#007FA3\",\"blue\":\"#0877A8\",\"indigo\":\"#4A6FA5\",\"violet\":\"#675FA3\",\"magenta\":\"#A84D5E\",\"rose\":\"#B85752\",\"red\":\"#B73D38\",\"orange\":\"#B75B31\",\"amber\":\"#946E00\",\"yellow\":\"#836F0A\",\"green\":\"#74772E\",\"mint\":\"#27826F\"},\"grays\":{\"gray0\":\"#DDEFF7\",\"gray1\":\"#F7FCFE\",\"gray2\":\"#D5EDF7\",\"gray3\":\"#82B6CE\",\"gray4\":\"#5C8396\",\"gray5\":\"#335F74\",\"gray6\":\"#0B2F44\"},\"uiGroups\":{\"backgroundShade\":\"#DDEFF7\",\"background\":\"#F7FCFE\",\"backgroundElevated\":\"#ECF7FC\",\"backgroundMuted\":\"#D5EDF7\",\"selection\":\"#BAE8F6\",\"foreground\":\"#0B2F44\",\"foregroundMuted\":\"#335F74\",\"foregroundSubtle\":\"#5C8396\",\"border\":\"#B9D8E6\",\"line\":\"#82B6CE\",\"userActionNeeded\":\"#B73D38\",\"userCurrentState\":\"#007FA3\",\"gray0\":\"#DDEFF7\",\"gray1\":\"#F7FCFE\",\"gray2\":\"#D5EDF7\",\"gray3\":\"#82B6CE\",\"gray4\":\"#5C8396\",\"gray5\":\"#335F74\",\"gray6\":\"#0B2F44\"},\"syntaxGroups\":{\"constant\":\"#007FA3\",\"identifier\":\"#0877A8\",\"statement\":\"#946E00\",\"type\":\"#74772E\",\"global\":\"#675FA3\",\"emphasis\":\"#A84D5E\",\"special\":\"#B75B31\",\"string\":\"#27826F\",\"regexp\":\"#B85752\",\"number\":\"#836F0A\",\"operator\":\"#4A6FA5\",\"tag\":\"#0877A8\",\"attribute\":\"#007FA3\",\"trivial\":\"#5C8396\"},\"versionControlGroups\":{\"added\":\"#74772E\",\"modified\":\"#946E00\",\"removed\":\"#B73D38\",\"renamed\":\"#0877A8\"},\"ansiGroups\":{\"normal\":{\"black\":\"#F7FCFE\",\"red\":\"#B73D38\",\"green\":\"#74772E\",\"yellow\":\"#946E00\",\"blue\":\"#0877A8\",\"magenta\":\"#A84D5E\",\"cyan\":\"#007FA3\",\"white\":\"#0B2F44\"},\"bright\":{\"black\":\"#5C8396\",\"red\":\"#B85752\",\"green\":\"#27826F\",\"yellow\":\"#836F0A\",\"blue\":\"#4A6FA5\",\"magenta\":\"#675FA3\",\"cyan\":\"#007FA3\",\"white\":\"#FFFFFF\"}}}}}");


function $0d095cbb34c076e5$export$5961024336e30d56() {
    return Promise.resolve((0, (/*@__PURE__*/$parcel$interopDefault($ae40fb19cfbdaff6$exports))));
}


function $c80d9596807b82f0$export$e6af5cbd5c288da2(id) {
    const template = document.getElementById(id);
    if (!(template instanceof HTMLTemplateElement)) throw new Error(`Missing #${id}.`);
    return template;
}


class $4e5478cc565c3516$var$ColorStage extends HTMLElement {
    static get observedAttributes() {
        return [
            "mode",
            "variant"
        ];
    }
    /** @type {any} */ #definitions = null;
    connectedCallback() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "group");
        this.#load();
    }
    attributeChangedCallback() {
        if (!this.#definitions) return;
        this.#render();
        this.#sync();
    }
    get variant() {
        const variant = this.getAttribute("variant");
        const variants = this.#definitions?.variants || {};
        return variant && variants[variant] ? variant : "metis";
    }
    set variant(value) {
        this.setAttribute("variant", value);
    }
    get mode() {
        const mode = this.getAttribute("mode");
        const themes = this.#definitions?.variants[this.variant].themes || {};
        return mode && themes[mode] ? mode : "dark";
    }
    set mode(value) {
        this.setAttribute("mode", value);
    }
    async #load() {
        this.#definitions = await (0, $0d095cbb34c076e5$export$5961024336e30d56)();
        this.#render();
        this.#sync();
    }
    #render() {
        const template = (0, $c80d9596807b82f0$export$e6af5cbd5c288da2)("color-stage-swatch-template");
        const fragment = document.createDocumentFragment();
        const variants = this.#definitions.variants;
        Object.keys(variants[this.variant].palette).forEach((name)=>{
            const figure = template.content.firstElementChild?.cloneNode(true);
            if (!(figure instanceof HTMLElement)) return;
            const button = figure.querySelector(".color-orb");
            const label = figure.querySelector("[data-color-label]");
            const value = figure.querySelector("[data-color-name]");
            if (!(button instanceof HTMLButtonElement) || !(label instanceof HTMLElement) || !(value instanceof HTMLElement)) return;
            button.classList.add(`orb-${name}`);
            button.dataset.copyColor = name;
            button.addEventListener("click", ()=>this.#copy(name, button));
            label.textContent = this.#label(name);
            value.dataset.colorName = name;
            fragment.append(figure);
        });
        this.replaceChildren(fragment);
    }
    #sync() {
        const theme = this.#definitions.variants[this.variant].themes[this.mode];
        const colors = /** @type {Record<string, string>} */ theme.colors;
        /** @type {NodeListOf<HTMLElement>} */ const nodes = this.querySelectorAll("[data-color-name]");
        nodes.forEach((node)=>{
            const name = node.dataset.colorName;
            if (!name || !colors[name]) return;
            const figure = /** @type {HTMLElement | null} */ node.closest(".color-swatch");
            const orb = /** @type {HTMLElement | null} */ figure?.querySelector(".color-orb") || null;
            node.textContent = colors[name];
            figure?.style.setProperty("--swatch-color", colors[name]);
            orb?.style.setProperty("--orb-color", colors[name]);
        });
    }
    /**
	 * @param {string} name
	 * @param {HTMLButtonElement} button
	 */ async #copy(name, button) {
        const colors = /** @type {Record<string, string>} */ this.#definitions.variants[this.variant].themes[this.mode].colors;
        const color = colors[name];
        try {
            await navigator.clipboard?.writeText(color);
            button.dataset.copied = "true";
            window.setTimeout(()=>{
                delete button.dataset.copied;
            }, 900);
        } catch  {
            button.dataset.copied = "false";
        }
    }
    /**
	 * @param {string} name
	 */ #label(name) {
        return name.replace(/^./, (letter)=>letter.toUpperCase());
    }
}
customElements.define("color-stage", $4e5478cc565c3516$var$ColorStage);


// @ts-check

var $ac76bc76dabcf352$exports = {};
$ac76bc76dabcf352$exports = import.meta.resolve("gwXf3");


var $ca69bda3feb7a2e6$exports = {};
$ca69bda3feb7a2e6$exports = import.meta.resolve("2dAze");


var $e1fcdfbe24bf08c3$exports = {};
$e1fcdfbe24bf08c3$exports = import.meta.resolve("ld0Mx");


var $d620313655ad441e$exports = {};
$d620313655ad441e$exports = import.meta.resolve("f4Ugq");


var $3419797f7095998b$exports = {};
$3419797f7095998b$exports = import.meta.resolve("iBNUm");


var $4d2a50066a0781d7$exports = {};
$4d2a50066a0781d7$exports = import.meta.resolve("aSvwD");


var $384122ab3bf66722$exports = {};
$384122ab3bf66722$exports = import.meta.resolve("bh6dK");


var $e5a143c7bf16040e$exports = {};
$e5a143c7bf16040e$exports = import.meta.resolve("3enL6");


var $ca18b57d0b78e5f1$exports = {};
$ca18b57d0b78e5f1$exports = import.meta.resolve("5PERi");


var $25b9adc4e2c843bb$exports = {};
$25b9adc4e2c843bb$exports = import.meta.resolve("gp2Fz");


var $b54a371921b651ec$exports = {};
$b54a371921b651ec$exports = import.meta.resolve("gLmjY");


var $f023eb43eb31ff10$exports = {};
$f023eb43eb31ff10$exports = import.meta.resolve("cW0FF");


const $e69a0ba3f6279ea2$var$iconSources = {
    "./assets/icons/light/iterm2.png": new URL($ac76bc76dabcf352$exports).toString(),
    "./assets/icons/dark/iterm2.png": new URL($ca69bda3feb7a2e6$exports).toString(),
    "./assets/icons/light/ghostty.png": new URL($e1fcdfbe24bf08c3$exports).toString(),
    "./assets/icons/dark/ghostty.png": new URL($d620313655ad441e$exports).toString(),
    "./assets/icons/light/codex.png": new URL($3419797f7095998b$exports).toString(),
    "./assets/icons/dark/codex.png": new URL($4d2a50066a0781d7$exports).toString(),
    "./assets/icons/light/vim.png": new URL($384122ab3bf66722$exports).toString(),
    "./assets/icons/dark/vim.png": new URL($e5a143c7bf16040e$exports).toString(),
    "./assets/icons/light/xcode.png": new URL($ca18b57d0b78e5f1$exports).toString(),
    "./assets/icons/dark/xcode.png": new URL($25b9adc4e2c843bb$exports).toString(),
    "./assets/icons/light/vscode.png": new URL($b54a371921b651ec$exports).toString(),
    "./assets/icons/dark/vscode.png": new URL($f023eb43eb31ff10$exports).toString()
};
class $e69a0ba3f6279ea2$var$OutputIcon extends HTMLElement {
    static get observedAttributes() {
        return [
            "light",
            "dark",
            "default",
            "mode"
        ];
    }
    /** @type {ShadowRoot} */ #root;
    constructor(){
        super();
        this.#root = this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.#render();
        this.#sync();
    }
    attributeChangedCallback() {
        this.#sync();
    }
    #render() {
        this.#root.replaceChildren((0, $c80d9596807b82f0$export$e6af5cbd5c288da2)("output-icon-template").content.cloneNode(true));
    }
    #sync() {
        const lightSource = this.#root.querySelector('[data-icon-source="light"]');
        const darkSource = this.#root.querySelector('[data-icon-source="dark"]');
        const image = this.#root.querySelector("img");
        if (!(lightSource instanceof HTMLSourceElement) || !(darkSource instanceof HTMLSourceElement) || !image) return;
        const mode = this.getAttribute("mode");
        const light = this.#source(this.getAttribute("light") || "");
        const dark = this.#source(this.getAttribute("dark") || "");
        const fallback = this.getAttribute("default") || dark || light;
        const source = mode ? this.#source(this.getAttribute(mode) || fallback) : this.#source(fallback);
        if (mode) {
            lightSource.srcset = source;
            darkSource.srcset = source;
        } else {
            lightSource.srcset = light;
            darkSource.srcset = dark;
        }
        image.src = source;
    }
    /**
	 * @param {string} source
	 */ #source(source) {
        return $e69a0ba3f6279ea2$var$iconSources[source] || source;
    }
}
customElements.define("output-icon", $e69a0ba3f6279ea2$var$OutputIcon);


// @ts-check

class $4ed0df556193d8d3$var$PresetDef extends HTMLElement {
    get presetId() {
        return this.getAttribute("id") || "";
    }
    get label() {
        return this.getAttribute("label") || this.textContent.trim() || this.presetId.replace(/^./, (letter)=>letter.toUpperCase());
    }
}
class $4ed0df556193d8d3$var$PresetSelector extends HTMLElement {
    static get observedAttributes() {
        return [
            "value"
        ];
    }
    /** @type {ShadowRoot} */ #root;
    /** @type {Map<string, HTMLButtonElement>} */ #buttons = new Map();
    constructor(){
        super();
        this.#root = this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.#render();
        this.#sync();
    }
    attributeChangedCallback() {
        this.#sync();
    }
    get value() {
        return this.getAttribute("value") || "";
    }
    set value(value) {
        this.setAttribute("value", value);
    }
    #render() {
        const defs = Array.from(this.querySelectorAll("preset-def"));
        this.#root.replaceChildren((0, $c80d9596807b82f0$export$e6af5cbd5c288da2)("preset-selector-template").content.cloneNode(true));
        const wrapper = this.#root.querySelector("[data-preset-options]");
        if (!(wrapper instanceof HTMLElement)) return;
        wrapper.setAttribute("aria-label", this.getAttribute("aria-label") || "Preset");
        wrapper.style.setProperty("--preset-count", String(defs.length || 1));
        this.#buttons.clear();
        defs.forEach((def)=>{
            if (!(def instanceof $4ed0df556193d8d3$var$PresetDef) || !def.presetId) return;
            const button = document.createElement("button");
            button.type = "button";
            button.textContent = def.label;
            button.dataset.presetOption = def.presetId;
            button.addEventListener("click", ()=>this.#select(def.presetId));
            wrapper.append(button);
            this.#buttons.set(def.presetId, button);
        });
    }
    /**
	 * @param {string} value
	 */ #select(value) {
        this.value = value;
        this.dispatchEvent(new CustomEvent("preset-change", {
            bubbles: true,
            detail: {
                value: value
            }
        }));
    }
    #sync() {
        this.#buttons.forEach((button, value)=>{
            button.setAttribute("aria-pressed", String(value === this.value));
        });
    }
}
customElements.define("preset-def", $4ed0df556193d8d3$var$PresetDef);
customElements.define("preset-selector", $4ed0df556193d8d3$var$PresetSelector);


// @ts-check
var $850a67666df146a0$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $850a67666df146a0$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $850a67666df146a0$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($850a67666df146a0$var$_self);
if ($850a67666df146a0$exports) $850a67666df146a0$exports = $850a67666df146a0$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $850a67666df146a0$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $850a67666df146a0$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$850a67666df146a0$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $850a67666df146a0$var$Prism.languages.markup['entity'];
$850a67666df146a0$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $850a67666df146a0$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$850a67666df146a0$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($850a67666df146a0$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $850a67666df146a0$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $850a67666df146a0$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($850a67666df146a0$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $850a67666df146a0$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $850a67666df146a0$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$850a67666df146a0$var$Prism.languages.html = $850a67666df146a0$var$Prism.languages.markup;
$850a67666df146a0$var$Prism.languages.mathml = $850a67666df146a0$var$Prism.languages.markup;
$850a67666df146a0$var$Prism.languages.svg = $850a67666df146a0$var$Prism.languages.markup;
$850a67666df146a0$var$Prism.languages.xml = $850a67666df146a0$var$Prism.languages.extend('markup', {});
$850a67666df146a0$var$Prism.languages.ssml = $850a67666df146a0$var$Prism.languages.xml;
$850a67666df146a0$var$Prism.languages.atom = $850a67666df146a0$var$Prism.languages.xml;
$850a67666df146a0$var$Prism.languages.rss = $850a67666df146a0$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($850a67666df146a0$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $850a67666df146a0$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $850a67666df146a0$var$Prism.languages.javascript = $850a67666df146a0$var$Prism.languages.extend('clike', {
    'class-name': [
        $850a67666df146a0$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$850a67666df146a0$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$850a67666df146a0$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $850a67666df146a0$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$850a67666df146a0$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $850a67666df146a0$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$850a67666df146a0$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($850a67666df146a0$var$Prism.languages.markup) {
    $850a67666df146a0$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $850a67666df146a0$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$850a67666df146a0$var$Prism.languages.js = $850a67666df146a0$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $850a67666df146a0$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $850a67666df146a0$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $850a67666df146a0$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $850a67666df146a0$var$Prism.util.setLanguage(code, language);
            $850a67666df146a0$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $850a67666df146a0$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $850a67666df146a0$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $850a67666df146a0$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$850a67666df146a0$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $850a67666df146a0$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $850a67666df146a0$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};


Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;


(function(Prism1) {
    Prism1.languages.typescript = Prism1.languages.extend('javascript', {
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    });
    // The keywords TypeScript adds to JavaScript
    Prism1.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.typescript['parameter'];
    delete Prism1.languages.typescript['literal-property'];
    // a version of typescript specifically for highlighting types
    var typeInside = Prism1.languages.extend('typescript', {});
    delete typeInside['class-name'];
    Prism1.languages.typescript['class-name'].inside = typeInside;
    Prism1.languages.insertBefore('typescript', 'function', {
        'decorator': {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                'at': {
                    pattern: /^@/,
                    alias: 'operator'
                },
                'function': /^[\s\S]+/
            }
        },
        'generic-function': {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        }
    });
    Prism1.languages.ts = Prism1.languages.typescript;
})(Prism);


Prism.languages.go = Prism.languages.extend('clike', {
    'string': {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    'keyword': /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    'boolean': /\b(?:_|false|iota|nil|true)\b/,
    'number': [
        // binary and octal integers
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        // hexadecimal integers and floats
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        // decimal integers and floats
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    'operator': /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    'builtin': /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
});
Prism.languages.insertBefore('go', 'string', {
    'char': {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
});
delete Prism.languages.go['class-name'];


Prism.languages.swift = {
    'comment': {
        // Nested comments are supported up to 2 levels
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    'string-literal': [
        // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
        {
            pattern: RegExp(/(^|[^"#])/.source + '(?:' + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'interpolation': {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null // see below
                },
                'interpolation-punctuation': {
                    pattern: /^\)|\\\($/,
                    alias: 'punctuation'
                },
                'punctuation': /\\(?=[\r\n])/,
                'string': /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
            lookbehind: true,
            greedy: true,
            inside: {
                'interpolation': {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null // see below
                },
                'interpolation-punctuation': {
                    pattern: /^\)|\\#+\($/,
                    alias: 'punctuation'
                },
                'string': /[\s\S]+/
            }
        }
    ],
    'directive': {
        // directives with conditions
        pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
        alias: 'property',
        inside: {
            'directive-name': /^#\w+/,
            'boolean': /\b(?:false|true)\b/,
            'number': /\b\d+(?:\.\d+)*\b/,
            'operator': /!|&&|\|\||[<>]=?/,
            'punctuation': /[(),]/
        }
    },
    'literal': {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: 'constant'
    },
    'other-directive': {
        pattern: /#\w+\b/,
        alias: 'property'
    },
    'attribute': {
        pattern: /@\w+/,
        alias: 'atrule'
    },
    'function-definition': {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: 'function'
    },
    'label': {
        // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: 'important'
    },
    'keyword': /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    'boolean': /\b(?:false|true)\b/,
    'nil': {
        pattern: /\bnil\b/,
        alias: 'constant'
    },
    'short-argument': /\$\d+\b/,
    'omit': {
        pattern: /\b_\b/,
        alias: 'keyword'
    },
    'number': /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
    'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    'function': /\b[a-z_]\w*(?=\s*\()/i,
    'constant': /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
    // This regex only supports ASCII operators.
    'operator': /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    'punctuation': /[{}[\]();,.:\\]/
};
Prism.languages.swift['string-literal'].forEach(function(rule) {
    rule.inside['interpolation'].inside = Prism.languages.swift;
});


(function(Prism1) {
    var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
    for(var i = 0; i < 2; i++)// support 4 levels of nested comments
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return multilineComment;
    });
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    });
    Prism1.languages.rust = {
        'comment': [
            {
                pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        'string': {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        'char': {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        'attribute': {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: 'attr-name',
            inside: {
                'string': null // see below
            }
        },
        // Closure params should not be confused with bitwise OR |
        'closure-params': {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                'closure-punctuation': {
                    pattern: /^\||\|$/,
                    alias: 'punctuation'
                },
                rest: null // see below
            }
        },
        'lifetime-annotation': {
            pattern: /'\w+/,
            alias: 'symbol'
        },
        'fragment-specifier': {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: 'punctuation'
        },
        'variable': /\$\w+/,
        'function-definition': {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: 'function'
        },
        'type-definition': {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: 'class-name'
        },
        'module-declaration': [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: 'namespace'
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: 'namespace',
                inside: {
                    'punctuation': /::/
                }
            }
        ],
        'keyword': [
            // https://github.com/rust-lang/reference/blob/master/src/keywords.md
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            // primitives and str
            // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        'function': /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        'macro': {
            pattern: /\b\w+!/,
            alias: 'property'
        },
        'constant': /\b[A-Z_][A-Z_\d]+\b/,
        'class-name': /\b[A-Z]\w*\b/,
        'namespace': {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                'punctuation': /::/
            }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        'number': /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        'boolean': /\b(?:false|true)\b/,
        'punctuation': /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        'operator': /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    };
    Prism1.languages.rust['closure-params'].inside.rest = Prism1.languages.rust;
    Prism1.languages.rust['attribute'].inside['string'] = Prism1.languages.rust['string'];
})(Prism);



const $75c048baeef54bbf$var$normalizeSource = (source)=>{
    const lines = source.replace(/\r\n?/g, "\n").split("\n");
    while(lines[0]?.trim() === "")lines.shift();
    while(lines.at(-1)?.trim() === "")lines.pop();
    const indentation = lines.filter((line)=>line.trim()).map((line)=>line.match(/^[\t ]*/)?.[0].length || 0);
    const trimLength = indentation.length ? Math.min(...indentation) : 0;
    return lines.map((line)=>line.slice(trimLength)).join("\n");
};
const $75c048baeef54bbf$var$labelForLanguage = (language)=>language.replace(/^./, (letter)=>letter.toUpperCase());
class $75c048baeef54bbf$var$SyntaxHighlighter extends HTMLElement {
    static get observedAttributes() {
        return [
            "file",
            "label",
            "language"
        ];
    }
    /** @type {string | null} */ #source = null;
    connectedCallback() {
        this.#source ??= this.#readSource();
        this.#render();
    }
    attributeChangedCallback() {
        if (this.isConnected && this.#source !== null) this.#render();
    }
    get language() {
        return this.getAttribute("language") || "javascript";
    }
    #render() {
        const template = (0, $c80d9596807b82f0$export$e6af5cbd5c288da2)("syntax-highlighter-template");
        const language = this.language;
        const grammar = (0, (/*@__PURE__*/$parcel$interopDefault($850a67666df146a0$exports))).languages[language];
        const source = this.#source || "";
        this.replaceChildren(template.content.cloneNode(true));
        const title = this.querySelector("[data-syntax-title]");
        const file = this.querySelector("[data-syntax-file]");
        const pre = this.querySelector("pre");
        const code = this.querySelector("[data-syntax-code]");
        if (!(title instanceof HTMLElement) || !(file instanceof HTMLElement) || !pre || !(code instanceof HTMLElement)) return;
        title.textContent = this.getAttribute("label") || $75c048baeef54bbf$var$labelForLanguage(language);
        file.textContent = this.getAttribute("file") || "";
        file.hidden = !file.textContent;
        pre.className = `language-${language}`;
        code.className = `language-${language}`;
        if (grammar) code.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($850a67666df146a0$exports))).highlight(source, grammar, language);
        else code.textContent = source;
    }
    #readSource() {
        const sourceTemplate = this.querySelector("[data-syntax-source]");
        const source = sourceTemplate instanceof HTMLTemplateElement ? sourceTemplate.content.querySelector("pre")?.textContent || sourceTemplate.content.textContent : this.textContent;
        return $75c048baeef54bbf$var$normalizeSource(source);
    }
}
customElements.define("syntax-highlighter", $75c048baeef54bbf$var$SyntaxHighlighter);



const $aa220e79c5ba66f0$var$REPOSITORY_CONTENT_BASE = "https://github.com/charliewilco/jupiter/blob/main";
const $aa220e79c5ba66f0$var$toKebab = (value)=>value.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
const $aa220e79c5ba66f0$var$toTitle = (value)=>`${value.slice(0, 1).toUpperCase()}${value.slice(1)}`;
const $aa220e79c5ba66f0$var$repositoryContentUrl = (...segments)=>`${$aa220e79c5ba66f0$var$REPOSITORY_CONTENT_BASE}/${segments.map(encodeURIComponent).join("/")}`;
const $aa220e79c5ba66f0$var$getInitialVariant = (definitions)=>{
    const variant = localStorage.getItem("jupiter-preview-variant");
    return variant && definitions.variants[variant] ? variant : "metis";
};
const $aa220e79c5ba66f0$var$getInitialMode = (definitions)=>{
    const mode = localStorage.getItem("jupiter-preview-mode");
    return mode && definitions.themes[mode] ? mode : "dark";
};
const $aa220e79c5ba66f0$var$setThemeVars = (theme)=>{
    const root = document.documentElement;
    const groups = [
        [
            "ui",
            theme.uiGroups
        ],
        [
            "syntax",
            theme.syntaxGroups
        ],
        [
            "version",
            theme.versionControlGroups
        ],
        [
            "color",
            theme.colors
        ],
        [
            "ansi",
            theme.ansiGroups.normal
        ]
    ];
    groups.forEach(([prefix, values])=>{
        Object.entries(values).forEach(([key, value])=>{
            root.style.setProperty(`--${prefix}-${$aa220e79c5ba66f0$var$toKebab(key)}`, value);
        });
    });
};
const $aa220e79c5ba66f0$var$syncOutputIcons = (mode)=>{
    document.querySelectorAll("output-icon").forEach((icon)=>{
        icon.setAttribute("mode", mode);
    });
};
const $aa220e79c5ba66f0$var$syncOutputLinks = (definitions, variant, mode)=>{
    const variantDefinition = definitions.variants[variant];
    const theme = variantDefinition.themes[mode];
    const variantName = variantDefinition.name;
    const modeName = $aa220e79c5ba66f0$var$toTitle(mode);
    const label = `${variantName} ${modeName}`;
    const outputLinks = {
        iterm: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("iterm", `${variantName} ${modeName}.itermcolors`),
            label: label
        },
        ghostty: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("ghostty", theme.slug),
            label: label
        },
        codex: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("codex", `${theme.slug}.json`),
            label: label
        },
        vim: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("colors", `${variant}.vim`),
            label: variantName
        },
        xcode: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("xcode", `${variantName} ${modeName}.xccolortheme`),
            label: label
        },
        vscode: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("vscode", "themes", `${theme.slug}-color-theme.json`),
            label: label
        },
        prismjs: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("prismjs", "jupiter.css"),
            label: "PrismJS"
        },
        shiki: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("shiki", `${theme.slug}.json`),
            label: "Shiki"
        },
        definitions: {
            href: $aa220e79c5ba66f0$var$repositoryContentUrl("definitions", "jupiter.json"),
            label: "source definitions"
        }
    };
    document.querySelectorAll("[data-output-link]").forEach((link)=>{
        if (!(link instanceof HTMLAnchorElement)) return;
        const output = link.dataset.outputLink || "";
        const target = outputLinks[output];
        if (!target) return;
        link.href = target.href;
        link.textContent = target.label;
        link.setAttribute("aria-label", `Open ${target.label} ${output} artifact`);
    });
};
const $aa220e79c5ba66f0$var$syncVariantSelector = (selector, variant)=>{
    const input = selector.querySelector(`input[value="${CSS.escape(variant)}"]`);
    if (input instanceof HTMLInputElement) input.checked = true;
};
const $aa220e79c5ba66f0$var$setPreview = (definitions, variant, mode)=>{
    const theme = definitions.variants[variant].themes[mode];
    const familySelector = document.querySelector("[data-family-selector]");
    const modeSelector = document.querySelector("[data-mode-selector]");
    const colorStage = document.querySelector("color-stage");
    document.documentElement.dataset.variant = variant;
    document.documentElement.dataset.mode = mode;
    document.documentElement.dataset.theme = theme.slug;
    localStorage.setItem("jupiter-preview-variant", variant);
    localStorage.setItem("jupiter-preview-mode", mode);
    $aa220e79c5ba66f0$var$setThemeVars(theme);
    $aa220e79c5ba66f0$var$syncOutputIcons(mode);
    $aa220e79c5ba66f0$var$syncOutputLinks(definitions, variant, mode);
    if (familySelector) $aa220e79c5ba66f0$var$syncVariantSelector(familySelector, variant);
    if (modeSelector) modeSelector.setAttribute("value", mode);
    if (colorStage) {
        colorStage.setAttribute("variant", variant);
        colorStage.setAttribute("mode", mode);
    }
};
const $aa220e79c5ba66f0$var$start = async ()=>{
    const definitions = await (0, $0d095cbb34c076e5$export$5961024336e30d56)();
    document.querySelector("[data-family-selector]")?.addEventListener("change", (event)=>{
        if (event.target instanceof HTMLInputElement && event.target.value in definitions.variants) $aa220e79c5ba66f0$var$setPreview(definitions, event.target.value, document.documentElement.dataset.mode || "dark");
    });
    document.querySelector("[data-mode-selector]")?.addEventListener("preset-change", (event)=>{
        if (event instanceof CustomEvent && typeof event.detail.value === "string") $aa220e79c5ba66f0$var$setPreview(definitions, document.documentElement.dataset.variant || "metis", event.detail.value);
    });
    $aa220e79c5ba66f0$var$setPreview(definitions, $aa220e79c5ba66f0$var$getInitialVariant(definitions), $aa220e79c5ba66f0$var$getInitialMode(definitions));
};
$aa220e79c5ba66f0$var$start();


//# sourceMappingURL=docs.626fd1d2.js.map
